import create from 'zustand'

import { INetworkContextData } from '@types'

const initialState = {
    isSoldOut: false,
    stage: 0,
    currentContractAddress: 0,
    contractName: '',
    currentMintPrice: '',
    selectedOption: 1,
    remainedTokenCount: -1,
    totalSupply: 0,
}
const useStore = create<INetworkContextData>(set => ({
    ...initialState,
    setIsSoldOut: value => set(() => ({ isSoldOut: value })),
    setStage: value => set(() => ({ stage: value })),
    setSelectedOption: value => set(() => ({ selectedOption: value })),
    setCurrentContractAddress: value => set(() => ({ currentContractAddress: value })),
    setContractName: value => set(() => ({ contractName: value })),
    setCurrentMintPrice: value => set(() => ({ currentMintPrice: value })),
    setRemainedTokenCount: value => set(() => ({ remainedTokenCount: value })),
    setTotalSupply: value => set(() => ({ totalSupply: value })),
    reset: () => {
        set({ ...initialState })
    },
}))
export default useStore
